import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const Footer = ({ currentLanguage }) => {
  const content = {
    es: {
      company: "Empresa",
      services: "Servicios",
      contact: "Contacto",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados",
      description: "Servicio profesional de limpieza y mantenimiento de piscinas en Costa Rica. Más de 8 años de experiencia garantizando la calidad del agua de tu piscina."
    },
    en: {
      company: "Company",
      services: "Services",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved",
      description: "Professional pool cleaning and maintenance service in Costa Rica. Over 8 years of experience guaranteeing the quality of your pool water."
    }
  };

  const companyLinks = [
    { labelEs: "Nosotros", labelEn: "About Us", path: "/about-us" },
    { labelEs: "Blog", labelEn: "Blog", path: "/blog-resources" },
    { labelEs: "Galería", labelEn: "Gallery", path: "/project-gallery" },
    { labelEs: "Contacto", labelEn: "Contact", path: "/contact-quote-request" }
  ];

  const serviceLinks = [
    { labelEs: "Limpieza Semanal", labelEn: "Weekly Cleaning", path: "/services-catalog" },
    { labelEs: "Mantenimiento", labelEn: "Maintenance", path: "/services-catalog" },
    { labelEs: "Emergencias", labelEn: "Emergency", path: "/services-catalog" },
    { labelEs: "Reparaciones", labelEn: "Repairs", path: "/services-catalog" }
  ];

  const socialLinks = [
    { name: "Facebook", icon: "Facebook", url: "https://facebook.com/bacpoolcr" },
    { name: "Instagram", icon: "Instagram", url: "https://instagram.com/bacpoolcr" },
    { name: "WhatsApp", icon: "MessageCircle", url: "https://wa.me/50686423175" },
    { name: "YouTube", icon: "Youtube", url: "https://youtube.com/bacpoolcr" }
  ];

  const text = content[currentLanguage];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-text-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Waves" size={24} color="white" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-primary">
                  BAC Pool CR
                </h3>
                <p className="text-xs font-caption text-white/70">
                  Pool Cleaning Services - bacpoolcr.online
                </p>
              </div>
            </div>
            
            <p className="text-white/80 text-sm mb-6">
              {text.description}
            </p>

            {/* Contact Info */}
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <Icon name="Phone" size={16} className="text-accent" />
                <span>+506 2253-4791</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="MessageCircle" size={16} className="text-accent" />
                <span>+506 8642-3175</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Mail" size={16} className="text-accent" />
                <span>info@bacpoolcr.online</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} className="text-accent" />
                <span>San José, Costa Rica</span>
              </div>
              <div className="flex items-center space-x-2">
                <span><a href="https://bacpoolcr.online/terms" className="text-white/60 hover:text-accent nav-transition">Terms of Service</a></span>
              </div>
              <div className="flex items-center space-x-2">
                <span><a href="https://bacpoolcr.online/privacy" className="text-white/60 hover:text-accent nav-transition">Privacy Policy</a></span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">{text.company}</h4>
            <ul className="space-y-2">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-accent nav-transition text-sm"
                  >
                    {currentLanguage === 'es' ? link.labelEs : link.labelEn}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Links */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">{text.services}</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-accent nav-transition text-sm"
                  >
                    {currentLanguage === 'es' ? link.labelEs : link.labelEn}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media & Newsletter */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">{text.followUs}</h4>
            
            {/* Social Links */}
            <div className="flex space-x-3 mb-6">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-primary nav-transition"
                  aria-label={social.name}
                >
                  <Icon name={social.icon} size={20} />
                </a>
              ))}
            </div>

            {/* Certifications */}
            <div className="space-y-2 text-xs text-white/60">
              <p>Cédula Jurídica: 3-101-789456</p>
              <p>Registro SENASA: PS-001-2019</p>
              <p>Certificación ISO 9001:2015</p>
              <p>Miembro CANAPROLI</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-white/60">
              © {currentYear} <a href="https://bacpoolcr.online">bacpoolcr.online</a>. {text.rights}.
            </div>
            
            <div className="flex items-center space-x-6 text-sm">
              <a href="https://bacpoolcr.online/privacy" className="text-white/60 hover:text-accent nav-transition">
                {currentLanguage === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}
              </a>
              <a href="https://bacpoolcr.online/terms" className="text-white/60 hover:text-accent nav-transition">
                {currentLanguage === 'es' ? 'Términos de Servicio' : 'Terms of Service'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
